import {FC} from "react";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";


const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            retryOnMount: false,
            refetchOnMount: false,
            refetchOnWindowFocus: false,
            cacheTime: 1,
            keepPreviousData: true,
        }
    }
});

const RequestsProvider: FC = (props) => (
    <QueryClientProvider client={queryClient}>
        {props.children}
    </QueryClientProvider>
)

export default RequestsProvider;
